











import {computed, defineComponent, reactive} from "@vue/composition-api"
import FusionChart from "@/components/charts/FusionChart.vue"
import WidgetFrame from "@/components/WidgetFrame.vue"

export default defineComponent({
  props: {opts: Object, value: String},
  components: {
    FusionChart, WidgetFrame,
  },
  setup(props, context) {
    const options = props.opts && props.opts.options || {}
    const state = reactive({
      inputId: `enum-${String(Math.floor((Math.random() * 100000)))}`,
      options: computed(() => options instanceof Map && [...options.keys()] || []),
    })

    function change(key: string) {
      context.emit('input', key)
    }

    return {state, change}
  },
})
